import React from 'react';
export function Hero() {
  return <section className="relative min-h-[85vh] flex flex-col items-center justify-center px-6 py-20 bg-white" data-id="element-46">
      <div className="w-full max-w-4xl mx-auto text-center space-y-12" data-id="element-47">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-48">
          <img src="https://cdn.magicpatterns.com/uploads/5XExtEKyTr7QhufVHxcNLt/MFC_Investco_Logo-RGB-High.jpg" alt="MFC Investco" className="h-24 md:h-32 w-auto object-contain" data-id="element-49" />
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-medium tracking-tight leading-tight text-navy" data-id="element-50">
          Stewarding Capital for <br className="hidden md:block" data-id="element-51" />
          Long-Term Impact
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed font-sans" data-id="element-52">
          Private investments and philanthropy focused on durable value,
          disciplined growth, and meaningful contribution.
        </p>

        {/* Decorative Line */}
        <div className="w-16 h-px bg-navy/20 mx-auto mt-12" data-id="element-53"></div>
      </div>
    </section>;
}